export default __webpack_public_path__ + "static/media/handshake.a4599faf.png";